import { Trans, useTranslation } from 'next-i18next'

import {
  Heading1,
  Paragraph,
  Section,
  Section1,
  Section2,
  Wrapper
} from '@/features/Listings/seo/elements'
import NearbyCities from '@/features/Listings/seo/search-results-content/content/poi/nearby-cities'
import NearbyPois from '@/features/Listings/seo/search-results-content/content/poi/nearby-pois'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'
import { toTitleCase } from '@/features/Listings/seo/search-results-content/content/utils'

const PoiContent = ({
  filterSlug = '',
  cityName,
  cityNameWithState,
  cityData,
  neighborhoodName,
  nearby
}) => {
  const { t } = useTranslation()
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  const filterTitleWithFallback = hasFilter
    ? toTitleCase(filterName)
    : t('seo.pois:Apartments Condos and Houses for Rent')

  const filterNameWithFallback = hasFilter
    ? filterName
    : t('seo.pois:apartments, condos, and houses for rent')

  return (
    <Wrapper>
      <Section>
        <Section1>
          <Section2>
            <Heading1>
              <Trans
                i18nKey="seo.pois:POI Content Heading"
                values={{
                  poiName: neighborhoodName,
                  cityName: cityName,
                  filterName: filterTitleWithFallback
                }}
                defaults="{{ cityName }} {{ filterName }} Near {{ poiName }}"
              />
            </Heading1>
            <Paragraph>
              <Trans i18nKey="seo.pois:POI Shopping Paragraph 1">
                Looking for the perfect balance of convenience and lifestyle?
                Living near {{ neighborhoodName }} means having everything you
                need just around the corner — from your favourite shops and
                restaurants to essential services and quick errands.
              </Trans>
            </Paragraph>
            <Paragraph>
              <Trans i18nKey="seo.pois:POI Shopping Paragraph 2">
                With liv.rent, finding {{ filterNameWithFallback }} near{' '}
                {{ neighborhoodName }} is easy, secure, and hassle-free. Browse
                verified listings, view photos and floor plans, and explore
                nearby transit options, pet policies, and amenities — all from
                one trusted platform.
              </Trans>
            </Paragraph>
            <Paragraph>
              <Trans i18nKey="seo.pois:POI Shopping Paragraph 3">
                Whether you’re a casual window-shopper or a weekend spree
                regular, having a rental steps from {{ neighborhoodName }}{' '}
                brings comfort and convenience to your daily routine. Start your
                search on liv.rent today and discover rentals that match your
                lifestyle — right where it all happens.
              </Trans>
            </Paragraph>
          </Section2>
        </Section1>
        <Section1>
          <NearbyPois
            filterSlug={filterSlug}
            poiName={neighborhoodName}
            nearby={nearby}
          />
        </Section1>
        <Section1>
          <NearbyCities
            cityData={cityData}
            cityNameWithState={cityNameWithState}
            filterSlug={filterSlug}
          />
        </Section1>
      </Section>
    </Wrapper>
  )
}

export default PoiContent
